/* eslint-disable no-sequences */

import React, { useEffect, useState, useContext } from "react";
import {
	Box,
	Button,
	Card,
	CardContent,
	Grid,
	IconButton,
	List,
	ListItem,
	ListItemText,
	Modal,
	TextField,
	Typography,
	CircularProgress,
	InputAdornment,
	Tooltip,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PlayArrow from "@mui/icons-material/PlayArrow";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { useNavigate } from "react-router-dom";
import { ModalFecha } from "./ModalFecha";
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import {
	LineChartMUI,
	RealObjectiveCards,
	ContractsDistributionChart,
	ContractsPieCharts,
} from "../Charts.jsx/ChartsMUI";

import SearchIcon from "@mui/icons-material/Search";
import {
	obtenerDatos,
	eliminarDato,
	agregarDato,
	obtenerParams,
	auditPost,
	actualizarDatoReview,
} from "../../api/config";
import Swal from "sweetalert2";
import { ModalFechaUpload } from "./ModalFechaUpload";
import { BarChart } from "@mui/icons-material";
import { ModalChart } from "./ModalChart";
import { GlobalContext } from "../../GlobalContext";
import { useTranslation } from "react-i18next";

const ModuleSimulation = () => {
	const [isLoadingData, setIsLoadingData] = useState(false);
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [loadingTaskId, setLoadingTaskId] = useState(null);
	const { isGranted, getModuleId, site_id } = useContext(GlobalContext);
	const [showlist, setShowlist] = useState(false);
	const [datos, setDatos] = useState([]);
	const [selectedItem, setSelectedItem] = useState();
	const [selectedItemTienda, setSelectedItemTienda] = useState();
	const [selectedItemContrato, setSelectedItemContrato] = useState();
	const [datosDefault, setDatosDefault] = useState();
	const [selectedItemDefaultTienda, setSelectedItemDefaultTienda] = useState();
	const [selectedItemDefaultContrato, setSelectedItemDefaultContrato] = useState();
	const [mostrarSelectedItem, setMostrarSelectedItem] = useState(true);
	const [isLoading, setIsLoading] = useState(true);
	const [openModalFile, setOpenModalFile] = useState(false);
	const [selectedItemDescription, setSelectedItemDescription] = useState();
	const [selectedItemName, setSelectedItemName] = useState();
	const [searchTermAvailable, setSearchTermAvailable] = useState("");
	const [selectedDate, setSelectedDate] = useState("");
	const [openModal, setOpenModal] = useState(false);
	const [open, setOpen] = useState(false);
	const [openModalChart, setOpenModalChart] = useState(false);
	const [selectedKey, setSelectedKey] = useState();
	const [isDownloading, setIsDownloading] = useState(false);

	const flowsStates = {
		1: { label: t("flows_states.1"), color: "warning.main", disabled: true },
		2: { label: t("flows_states.2"), color: "success.main", disabled: true },
		3: { label: t("flows_states.3"), color: "error.main", disabled: true },
		4: { label: "Mandar a revisar", color: "primary.main", disabled: false },
		unknown: { label: t("flows_states.unknown"), color: "grey.500", disabled: true },
	};

	// Obtener datos de simulación
	useEffect(() => {
		const simulacionDefault = async () => {
			setIsLoading(true);
			try {
				if (site_id !== null) {
					const datosDefault = await obtenerDatos(`/simulacion/get_default/${site_id}`);
					const datos = await obtenerDatos(`/simulacion/by_site_id/${site_id}`);

					setDatos(datos);

					setDatosDefault(datosDefault);
					setShowlist(true);
				}
			} catch (error) {
				console.error("Error al obtener datos de la simulación por defecto:", error);
			} finally {
				setIsLoading(false);
			}
		};
		simulacionDefault();
	}, [site_id]);

	const filterDatos = (datos, searchTerm, date) => {
		if (searchTerm) {
			return Object.keys(datos || {})
				.filter((key) => {
					const simulacionId = datos[key].simulacion_id;
					const name = datos[key].name || "";

					// Convertimos simulacion_id a string para evitar errores al usar includes.
					const simulacionIdStr = simulacionId ? String(simulacionId) : "";

					return (
						key.toLowerCase().includes(searchTerm) ||
						name.toLowerCase().includes(searchTerm) ||
						simulacionIdStr.includes(searchTerm)
					);
				})
				.reduce((res, key) => ((res[key] = datos[key]), res), {});
		} else if (date) {
			return Object.keys(datos || {})
				.filter((key) => datos[key].action_datetime.startsWith(date))
				.reduce((res, key) => ((res[key] = datos[key]), res), {});
		}
		return datos;
	};

	const filteredDatos = filterDatos(datos, searchTermAvailable.toLowerCase(), selectedDate);

	const handleSearchChange = (e) => {
		setSearchTermAvailable(e.target.value.toLowerCase());
		setSelectedDate("");
	};

	const handleDateChange = (e) => {
		setSelectedDate(e.target.value);
		setSearchTermAvailable("");
	};

	const handleModalChart = (key) => {
		setSelectedKey(key);
		setOpenModalChart(true);

		const moduleId = getModuleId("Simulación", "Ver resultados de simulación");
		auditPost(moduleId, site_id);
	};

	const handleCloseModal = () => {
		setOpenModal(false);
		setOpenModalChart(false);
	};
	const handleOpenDefault = () => {
		setOpen(true);

		setSelectedItem(undefined);
	};

	const handleOpen = (index) => {
		setOpen(true);
		const selectedItem = datos[index];

		setSelectedItem(selectedItem);
	};

	const combineContractsData = (contractsPerDay, contractsPerPeriods) => {
		const combinedContracts = [];
		const dayNames = [
			t("aux.days.lunes"),
			t("aux.days.martes"),
			t("aux.days.miercoles"),
			t("aux.days.jueves"),
			t("aux.days.viernes"),
			t("aux.days.sabado"),
			t("aux.days.domingo"),
		];

		contractsPerDay.forEach((dayContract) => {
			const { config_contracts_per_days_id, day, value, ...rest } = dayContract;
			if (value === 0) {
				combinedContracts.push({
					day: dayNames[day], // Cambiar el número del día por el nombre del día
					...rest,
					periods: [{ start_time: t("aux.no_available"), end_time: "" }],
				});
				return; // Continuar al siguiente elemento
			}

			const correspondingPeriod = contractsPerPeriods.find(
				(period) => period.config_contracts_per_days_id === config_contracts_per_days_id
			);

			const existingDay = combinedContracts.find((contract) => contract.day === day);

			if (existingDay) {
				existingDay.periods = [
					...existingDay.periods,
					...(correspondingPeriod ? correspondingPeriod.periods : []),
				];
			} else {
				combinedContracts.push({
					day: dayNames[day], // Cambiar el número del día por el nombre del día
					...rest,
					periods: correspondingPeriod ? correspondingPeriod.periods : [],
				});
			}
		});

		// Verificar y actualizar periodos no disponibles
		combinedContracts.forEach((contract) => {
			contract.periods = contract.periods.map(({ start_time, end_time }) => {
				if ((start_time === "00:00:00" && end_time === "00:00:00") || start_time === end_time) {
					return { start_time: "No disponible", end_time: "" };
				}
				return { start_time, end_time };
			});
		});

		return combinedContracts;
	};

	const handleClose = () => setOpen(false);
	const [selectedSimId, setSelectedSimId] = useState();

	const handleVisibility = (index) => {
		const selectedItem = datos[index];
		setSelectedSimId(selectedItem.simulacion_id);
		const cardData = selectedItem.config_tienda;
		const cardDataContrato = selectedItem.config;
		const cardDataDefault = datosDefault[0];
		const cardDataDefaultTienda = cardDataDefault.config_tienda;
		const cardDataDefaultContrato = cardDataDefault.config;
		const cardDataDescription = selectedItem.description;
		const cardDataName = selectedItem.name;

		if (cardData.length === 0 || cardDataContrato.length === 0) {
			setSelectedItemTienda(cardDataDefaultTienda);
			setSelectedItemContrato(cardDataDefaultContrato);
			setSelectedItemDescription(cardDataDescription);
			setSelectedItemName(cardDataName);
		} else {
			setSelectedItemTienda(cardData);
			setSelectedItemContrato(cardDataContrato);
			setSelectedItemDescription(cardDataDescription);
			setSelectedItemName(cardDataName);
		}

		setSelectedItem(selectedItem); // data completa
		setMostrarSelectedItem(true);
		setOpenModal(true);
		// enviar moduleId a la auditoria
		const moduleId = getModuleId(
			"Simulación",
			"Funcionalidad de ver datos de simulación historial (ojito)"
		);
		auditPost(moduleId, site_id);
	};

	const handleVisibilityDefault = (index) => {
		const selectedItemDefault = datosDefault[index];
		const cardDataDefault = selectedItemDefault.config_tienda;
		const cardDataContratoDefault = selectedItemDefault.config;
		setSelectedItemDefaultTienda(cardDataDefault);
		setSelectedItemDefaultContrato(cardDataContratoDefault);
		setMostrarSelectedItem(false);
		setOpenModal(true);
		// enviar moduleId a la auditoria
		const moduleId = getModuleId(
			"Simulación",
			"Funcionalidad de ver datos de simulación default (ojito)"
		);
		auditPost(moduleId, site_id);
	};

	const getBackendPayload = (resOrResponse) => {
		if (!resOrResponse) return null;

		if (typeof resOrResponse === "object" && "data" in resOrResponse) {
			return resOrResponse.data;
		}

		return resOrResponse;
	};

	const getBackendMessage = (resOrResponse) => {
		const payload = getBackendPayload(resOrResponse);
		if (!payload) return "";

		if (typeof payload === "string") return payload;

		if (typeof payload === "object") {
			return payload.message || payload.detail || payload.msg || payload.error || "";
		}

		return "";
	};

	const handleExecuteSimulation = (
		fechaInicio,
		fechaFin,
		checked,
		formValues,
		emailNotifications,
		selectedForecast
	) => {
		const baseData = {
			site_id: site_id,
			name: formValues.name,
			description: formValues.description,
			start: fechaInicio,
			end: fechaFin,
			send_mail: emailNotifications,
			forecast_origin: checked,
		};

		const isFromOrigin = selectedForecast && selectedForecast.fromOrigin;

		const datosEndpoint = {
			...baseData,
			...(isFromOrigin ? {} : selectedForecast ? { forecast_id: selectedForecast } : {}),
		};

		if (selectedItem) {
			if (selectedItem.config_tienda && Object.keys(selectedItem.config_tienda).length > 0) {
				datosEndpoint.config_tienda = selectedItem.config_tienda;
			}
			if (selectedItem.config && selectedItem.config.length > 0) {
				datosEndpoint.config = selectedItem.config;
			}
		}

		Swal.fire({
			title: t("aux.messages.sure"),
			text: t("aux.messages.not_revert"),
			icon: "question",
			showCancelButton: true,
			confirmButtonColor: "#3085d6",
			cancelButtonColor: "#d33",
			confirmButtonText: t("aux.buttons.yes"),
		}).then((result) => {
			if (!result.isConfirmed) return;

			Swal.fire({
				title: t("aux.messages.alert.info"),
				text: t("aux.messages.alert.text_alert.wait_sim"),
				icon: "info",
				allowOutsideClick: false,
				showConfirmButton: false,
				didOpen: () => Swal.showLoading(),
			});

			agregarDato("/launch", datosEndpoint)
				.then((res) => {
					const backendMessage = getBackendMessage(res);
					const successText = backendMessage || t("aux.messages.alert.text_alert.success_sim");

					const moduleName =
						selectedItem === undefined
							? "Ejecutar simulación por default"
							: "Ejecutar simulación de historial";

					const moduleId = getModuleId("Simulación", moduleName);
					auditPost(moduleId, site_id);

					setIsLoadingData(true);
					return obtenerDatos(`/simulacion/by_site_id/${site_id}`).then((updatedDatos) => {
						setDatos(updatedDatos);
						setIsLoadingData(false);

						Swal.close();

						Swal.fire({
							title: t("aux.messages.alert.success"),
							text: successText,
							icon: "success",
							confirmButtonColor: "#3085d6",
						});
					});
				})
				.catch((error) => {
					console.error("Error al enviar la simulación:", error);
					Swal.close();

					const backendMessage = getBackendMessage(error?.response);

					const errorText = backendMessage || t("aux.messages.alert.text_alert.error_sim");

					Swal.fire({
						title: t("aux.messages.alert.error"),
						text: errorText,
						icon: "error",
						confirmButtonColor: "#d33",
					});
				});
		});
	};

	const handleDelete = (key) => {
		const selectedItem = datos[key].simulacion_id;
		Swal.fire({
			title: t("aux.messages.sure"),
			text: t("aux.messages.not_revert"),
			icon: "warning",
			showCancelButton: true,
			confirmButtonColor: "#3085d6",
			cancelButtonColor: "#d33",
			confirmButtonText: t("aux.buttons.yes"),
		}).then((result) => {
			if (result.isConfirmed) {
				eliminarDato("/simulacion/delete", selectedItem, site_id);
				const moduleId = getModuleId("Simulación", "Eliminar simulación");
				auditPost(moduleId, site_id);
				Swal.fire({
					title: t("aux.messages.alert.delete"),
					text: t("aux.messages.alert.text_alert.delete_sim"),
					icon: "success",
				}).then(() => {
					setDatos((prevDatos) => {
						const newData = { ...prevDatos };
						delete newData[key];
						return newData;
					});
				});
			}
		});
	};
	const handleModalFile = () => {
		setOpenModalFile(true);
	};

	const handleClickButtonFile = async () => {
		setIsDownloading(true);
		try {
			const datosForecast = await obtenerParams(
				`/simulacion/get_params/${selectedSimId}?site_id=${site_id}`,
				null
			);

			const url = window.URL.createObjectURL(new Blob([datosForecast]), {
				type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
			});
			const link = document.createElement("a");
			link.href = url;
			// eslint-disable-next-line no-useless-concat
			link.setAttribute("download", "params" + ".xlsx");
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			Swal.fire({
				title: t("aux.messages.alert.success"),
				text: t("aux.messages.alert.text_alert.download_success"),
				icon: "success",
			});
		} catch (error) {
			Swal.fire({
				title: t("aux.messages.alert.error"),
				text: t("aux.messages.alert.text_alert.error_download"),
				icon: "error",
			});
			console.error("Error al obtener forecast:", error);
		} finally {
			setIsDownloading(false);
			handleCloseModal();
		}
	};

	const convertToBrowserTime = (utcDateString) => {
		const utcDate = new Date(utcDateString); // Convierte la cadena UTC a un objeto Date
		const localDate = new Date(utcDate.getTime() - utcDate.getTimezoneOffset() * 60000); // Ajusta a la hora local
		return localDate.toLocaleString(); // Convierte a cadena en la hora local del navegador
	};
	const handleUpdateStatus = async (task_id) => {
		setLoadingTaskId(task_id);

		try {
			await actualizarDatoReview(
				`/task/update_status/?task_id=${task_id}&status_id=1&site_id=${site_id}`
			);

			Swal.fire({
				title: t("aux.messages.alert.success"),
				text: t("aux.messages.alert.text_alert.review_success"),
				icon: "success",
			});

			const updatedDatos = await obtenerDatos(`/simulacion/by_site_id/${site_id}`);

			setDatos(updatedDatos);
		} catch (error) {
			const errorMessage = error?.response?.data || t("aux.messages.alert.error_update");

			Swal.fire({
				title: t("aux.messages.alert.error"),
				text: errorMessage,
				icon: "error",
			});

			const updatedDatos = await obtenerDatos(`/simulacion/by_site_id/${site_id}`);

			// 3. Actualizamos en memoria (sin llamar a fetchSimulationData)
			setDatos(updatedDatos);
		} finally {
			setLoadingTaskId(null);
		}
	};

	return (
		<>
			{/* container principal */}
			<Box
				sx={{
					width: "100%",
					p: 2,
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					alignItems: "center",
				}}
			>
				<Typography variant="h5" gutterBottom>
					{t("sim.title_module")}
				</Typography>
				{/* container Selects y listas */}
				<Box
					sx={{
						p: 2,
						width: "75%",
					}}
				>
					{isLoading ? ( // Mostrar la pantalla de carga si isLoading es true
						<Box
							sx={{
								mt: 4,
								width: "100%",
								display: "flex",
								flexDirection: "column",
								justifyContent: "center",
								alignItems: "center",
							}}
						>
							<CircularProgress color="primary" />
						</Box>
					) : (
						showlist && ( // Mostrar la lista de simulaciones si showlist es true
							<>
								{/* contenedor de simulaciones */}
								<Box
									sx={{
										mt: 2,
										width: "100%",
										display: "flex",
										flexDirection: "column",
										justifyContent: "center",
										alignItems: "center",
									}}
								>
									{/* Simulacion por defecto */}
									<Box
										sx={{
											width: "100%",
											p: 2,
											border: 1,
											borderColor: "secondary.main",
											borderRadius: 1,
										}}
									>
										<List
											sx={{
												border: 1,
												borderColor: "secondary.main",
												borderRadius: 1,
												width: "100%",
												backgroundColor: "background.paper",
											}}
										>
											{Object.keys(datosDefault).length === 0 ? (
												<ListItem>
													<ListItemText primary={t("aux.no_data")} sx={{ textAlign: "center" }} />
												</ListItem>
											) : (
												Object.keys(datosDefault).map((key, index) => (
													<ListItem
														sx={{
															width: "100%",
															height: "8vh",
														}}
														key={key}
													>
														<Button
															disabled={!isGranted("Simulación", "Ejecutar simulación por default")}
															variant="contained"
															color="primary"
															onClick={() => handleOpenDefault()}
															size="small"
															sx={{ width: "10%" }}
														>
															{t("aux.buttons.sim.execute")}
														</Button>

														<ListItemText
															primary={t("sim.sim_default")}
															secondary={t("sim.sim_default_desc")}
															sx={{ p: 2, textAlign: "center" }}
														/>
														<IconButton
															disabled={
																!isGranted("Simulación", "Funcionalidad de ver datos de simulación default (ojito)")
															}
															color="primary"
															sx={{ p: 2 }}
															onClick={() => handleVisibilityDefault(key)}
														>
															<VisibilityIcon />
														</IconButton>
													</ListItem>
												))
											)}
										</List>
									</Box>

									{/* Lista de simulaciones anteriores */}
									<Typography variant="h5" gutterBottom sx={{ p: 2, m: 2 }}>
										{t("sim.sim_historial")}
									</Typography>

									<Box
										sx={{
											width: "100%",
											height: "35vh",
											px: 3,
											py: 1,
											border: 1,
											borderColor: "secondary.main",
											borderRadius: 1,
											justifyContent: "space-between",
											overflowY: "auto",
										}}
									>
										<List>
											<Grid container spacing={2}>
												<Grid item xs={9}>
													<TextField
														sx={{
															width: "100%",
															borderColor: "secondary.main",
															mb: 2,
														}}
														label={t("aux.search")}
														size="small"
														value={searchTermAvailable}
														onChange={handleSearchChange}
														InputProps={{
															endAdornment: (
																<InputAdornment position="end">
																	<IconButton>
																		<SearchIcon />
																	</IconButton>
																</InputAdornment>
															),
														}}
														type="search"
													/>
												</Grid>
												<Grid item xs={3}>
													<TextField
														sx={{
															width: "100%",
															borderColor: "secondary.main",
															mb: 2,
														}}
														label={t("aux.date")}
														size="small"
														value={selectedDate}
														onChange={handleDateChange}
														type="date"
														InputLabelProps={{
															shrink: true,
														}}
													/>
												</Grid>
											</Grid>
											{isLoadingData && (
												<ListItem>
													<ListItemText
														primary={<CircularProgress size={24} />}
														secondary={t("aux.loading")}
														sx={{ textAlign: "center" }}
													/>
												</ListItem>
											)}
											{Object.keys(filteredDatos).length === 0 ? (
												<ListItem>
													<ListItemText primary={t("aux.no_data")} sx={{ textAlign: "center" }} />
												</ListItem>
											) : (
												Object.keys(filteredDatos).map((key) => {
													const simulation = filteredDatos[key];
													const task_status = simulation.task_status;
													const flows_states_id = simulation.flows_states_id;

													// Determinar el color y estado del botón "Ver Resultados" según task_status
													let buttonColor;
													let isDisabled;

													switch (task_status) {
														case "infactible":
															buttonColor = "error.main"; // Rojo
															isDisabled = true;
															break;
														case "finalizado":
															buttonColor = "success.main"; // Verde
															isDisabled = false;
															break;
														case "ejecutando":
															buttonColor = "grey.500"; // Gris
															isDisabled = true;
															break;
														default:
															buttonColor = "grey.500"; // Gris por defecto
															isDisabled = true;
													}

													// Determinar las propiedades para el botón "Revisar Simulaciones"
													let reviewButton = null;
													if (task_status !== "infactible" && task_status !== "ejecutando") {
														const flowState = flowsStates[flows_states_id] || {
															label: "Estado Desconocido",
															color: "grey.500",
															disabled: true,
														};
														reviewButton = (
															<Tooltip title={flowState.label}>
																<span>
																	<IconButton
																		disabled={flowState.disabled}
																		sx={{
																			p: 2,
																			color: flowState.color, // Color según estado
																			// Personalizar color cuando está deshabilitado
																			"&.Mui-disabled": {
																				color:
																					flows_states_id === 1
																						? "warning.main"
																						: flows_states_id === 2
																						? "success.main"
																						: flows_states_id === 3
																						? "error.main"
																						: "grey.500",
																			},
																		}}
																		onClick={() => handleUpdateStatus(simulation.task_id)}
																	>
																		{loadingTaskId === simulation.task_id ? (
																			<CircularProgress size={24} color="inherit" />
																		) : (
																			<ContentPasteSearchIcon />
																		)}
																	</IconButton>
																</span>
															</Tooltip>
														);
													}

													return (
														<ListItem
															sx={{
																width: "100%",
																height: "8vh",
																border: 1,
																borderColor: "secondary.main",
																borderRadius: 1,
																my: 1,
																backgroundColor: "background.paper",
															}}
															key={key}
														>
															{/* Botón para ejecutar simulación */}
															<IconButton
																disabled={!isGranted("Simulación", "Ejecutar simulación de historial")}
																color="primary"
																onClick={() => handleOpen(key)}
																sx={{ p: 2 }}
															>
																<PlayArrow />
															</IconButton>

															{/* Botón para ver detalles de la simulación */}
															<IconButton
																disabled={
																	!isGranted(
																		"Simulación",
																		"Funcionalidad de ver datos de simulación historial (ojito)"
																	)
																}
																color="primary"
																sx={{ p: 2 }}
																onClick={() => handleVisibility(key)}
															>
																<VisibilityIcon />
															</IconButton>

															{/* Botón "Ver Resultados" con personalización de color y estado */}
															<Tooltip
																title={
																	task_status === "infactible"
																		? t("tooltips.infactible")
																		: task_status === "ejecutando"
																		? t("tooltips.ejecutando")
																		: t("tooltips.ver_resultados")
																}
																disableHoverListener={task_status === "finalizado"}
															>
																<span>
																	<IconButton
																		disabled={isDisabled || !isGranted("Simulación", "Ver resultados de simulación")}
																		sx={{
																			p: 2,
																			color: buttonColor, // Color según estado
																			// Personalizar color cuando está deshabilitado
																			"&.Mui-disabled": {
																				color: task_status === "infactible" ? "error.main" : "grey.500",
																			},
																		}}
																		onClick={() => handleModalChart(filteredDatos[key].simulacion_id)}
																	>
																		<BarChart />
																	</IconButton>
																</span>
															</Tooltip>

															{/* Botón "Revisar Simulaciones" */}
															{reviewButton}

															{/* Información de la simulación */}
															<ListItemText
																primary={` ${filteredDatos[key].simulacion_id} | ${filteredDatos[key].name}  `}
																secondary={`${t("aux.made")}: ${convertToBrowserTime(
																	filteredDatos[key].action_datetime
																)}`}
																sx={{ textAlign: "center" }}
															/>

															{/* Botón para eliminar simulación */}
															<IconButton
																disabled={
																	!isGranted("Simulación", "Eliminar simulación") ||
																	flows_states_id === 1 ||
																	flows_states_id === 2
																}
																edge="end"
																aria-label="delete"
																color="error"
																sx={{ p: 2 }}
																onClick={() => handleDelete(key)}
															>
																<DeleteIcon />
															</IconButton>
														</ListItem>
													);
												})
											)}
										</List>
									</Box>
								</Box>
								{/* Botones de ejecutar simulación con archivo y crear formulario de simulación */}
								<Box
									sx={{
										mt: 2,
										width: "100%",
										display: "flex",
										justifyContent: "space-between",
									}}
								>
									<Button
										disabled={!isGranted("Simulación", "Ejecutar desde archivo")}
										color="primary"
										variant="contained"
										size="small"
										sx={{ width: "30%" }}
										onClick={handleModalFile}
									>
										{t("aux.buttons.sim.execute_file")}
									</Button>
									<Button
										disabled={!isGranted("Simulación", "Crear formulario de simulación (simulación desde 0)")}
										color="primary"
										variant="contained"
										size="small"
										sx={{ width: "30%" }}
										onClick={() => {
											navigate("/simulation/modifysimulation");
										}}
									>
										{t("aux.buttons.sim.create_sim")}
									</Button>
								</Box>
							</>
						)
					)}
				</Box>
			</Box>

			{/* Modal para mostrar el gráfico */}
			<ModalChart open={openModalChart} onClose={handleCloseModal} initialData={selectedKey} />

			{/* Modal para seleccionar la fecha de la simulación a repetir */}
			<ModalFecha
				open={open}
				onClose={handleClose}
				onExecuteSimulation={handleExecuteSimulation} // Pasar la función para ejecutar simulación
			/>
			{/* Modal para mostrar la información de la simulación */}
			<Modal
				open={openModal}
				onClose={handleCloseModal}
				sx={{
					width: "100%",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
				}}
			>
				<Card
					sx={{
						width: "70%",
						height: "70%",
						overflowY: "auto",
					}}
				>
					<CardContent>
						<Box
							sx={{
								display: "flex",
								justifyContent: "center",
								flexDirection: "column",
								width: "100%",
								px: 3,
								py: 2,
							}}
						>
							<Box sx={{ flexGrow: 1 }}></Box>
							{mostrarSelectedItem ? (
								<>
									<Grid container spacing={2} alignItems="center">
										<Grid item xs={9} sm={9}>
											<Typography variant="h6" gutterBottom>
												{t("sim.pop_up.title")}
												{selectedItemName ? `"${selectedItemName}"` : t("aux.no_data")}
											</Typography>
										</Grid>

										{selectedItemTienda && (
											<Grid item xs={3} sm={3} textAlign="right">
												<Button
													color="primary"
													variant="outlined"
													size="small"
													startIcon={<FileDownloadIcon />}
													onClick={handleClickButtonFile}
													disabled={isDownloading}
													fullWidth
												>
													{isDownloading ? t("aux.downloading") : t("aux.buttons.download")}
												</Button>
											</Grid>
										)}
									</Grid>
									<Typography variant="body3" gutterBottom>
										{t("sim.pop_up.desc_sim")}
									</Typography>

									<ul>
										<li>{selectedItemDescription ? selectedItemDescription : t("aux.no_data")}</li>
									</ul>

									<Typography variant="body3" gutterBottom>
										{t("sim.pop_up.conf_site")}
									</Typography>
									<ul>
										{selectedItemTienda && Object.keys(selectedItemTienda).length > 0 ? (
											Object.entries(selectedItemTienda).map(
												([key, value]) =>
													// omitir
													key !== "id" &&
													key !== "site_id" &&
													key !== "task_id" &&
													key !== "mes_not_cambio" &&
													key !== "largo_periodo" &&
													key !== "maximo_turnos" &&
													key !== "periodos_abierto" &&
													key !== "horas_no_funcionamiento_tienda" && (
														<li key={key}>
															{key}: {JSON.stringify(value)}
														</li>
													)
											)
										) : (
											<p>{t("sim.pop_up.no_sites")}</p>
										)}
									</ul>
									<Typography variant="body3" gutterBottom>
										{t("sim.pop_up.conf_contract")}
									</Typography>
									<Grid container spacing={2}>
										{selectedItemContrato && selectedItemContrato.length > 0 ? (
											selectedItemContrato.map((contract, index) => {
												// Combinar los datos solo una vez por contrato
												const combinedData = combineContractsData(
													contract.contracts_per_day,
													contract.contracts_per_periods
												);

												return (
													<Grid item xs={12} sm={7} md={5} lg={4} key={index}>
														<ul>
															{Object.entries(contract).map(([subKey, subValue]) => {
																// Mostrar contracts_per_day y contracts_per_periods usando combinedData
																if (subKey === "contracts_per_day" || subKey === "contracts_per_periods") {
																	return null; // No mostrar estos arrays originales
																}
																if (
																	["id", "config_site_id", "task_id", "contratos", "id_tipo_contrato"].includes(
																		subKey
																	)
																) {
																	return null;
																}
																return (
																	<li key={subKey}>
																		{subKey}: {typeof subValue === "boolean" ? subValue.toString() : subValue}
																	</li>
																);
															})}
															{/* Mostrar datos combinados */}
															<li>
																<strong>{t("aux.period")}:</strong>
																<ul>
																	{combinedData.map(({ day, periods, ...rest }) => (
																		<li key={day}>
																			{`${day}:`}
																			<ul>
																				{periods.length > 0 ? (
																					periods.map(({ start_time, end_time }, index) => (
																						<li key={index}>{`${start_time} - ${end_time}`}</li>
																					))
																				) : (
																					<li>{t("aux.no_period")}</li>
																				)}
																			</ul>
																		</li>
																	))}
																</ul>
															</li>
														</ul>
													</Grid>
												);
											})
										) : (
											<p>{t("aux.no_data")}</p>
										)}
									</Grid>
								</>
							) : (
								<>
									<Typography variant="h6" gutterBottom>
										{t("sim.pop_up.title")}
									</Typography>
									<Typography variant="body3" gutterBottom>
										{t("sim.pop_up.desc_sim")}
									</Typography>
									<ul>
										<li>{t("sim.pop_up.desc_sim_default")}</li>
									</ul>

									<Typography variant="body3" gutterBottom>
										{t("sim.pop_up.conf_site")}
									</Typography>
									<ul>
										{selectedItemDefaultTienda &&
											Object.entries(selectedItemDefaultTienda).map(
												([key, value]) =>
													// omitir id y task_id
													key !== "id" &&
													key !== "site_id" &&
													key !== "task_id" &&
													key !== "mes_not_cambio" &&
													key !== "largo_periodo" &&
													key !== "maximo_turnos" &&
													key !== "periodos_abierto" &&
													key !== "horas_no_funcionamiento_tienda" && (
														<li key={key}>
															{key}: {JSON.stringify(value)}
														</li>
													)
											)}
									</ul>
									<Typography variant="body3" gutterBottom>
										{t("sim.pop_up.conf_contract")}
									</Typography>
									<Grid container spacing={2}>
										{selectedItemDefaultContrato &&
											selectedItemDefaultContrato.map((contract, index) => {
												// Combinar los datos solo una vez por contrato
												const combinedData = combineContractsData(
													contract.contracts_per_day,
													contract.contracts_per_periods
												);

												return (
													<Grid item xs={12} sm={7} md={5} lg={4} key={index}>
														<ul>
															{Object.entries(contract).map(([subKey, subValue]) => {
																// Mostrar contracts_per_day y contracts_per_periods usando combinedData
																if (subKey === "contracts_per_day" || subKey === "contracts_per_periods") {
																	return null; // No mostrar estos arrays originales
																}
																if (
																	["id", "config_site_id", "task_id", "contratos", "id_tipo_contrato"].includes(
																		subKey
																	)
																) {
																	return null;
																}
																return (
																	<li key={subKey}>
																		{subKey}: {typeof subValue === "boolean" ? subValue.toString() : subValue}
																	</li>
																);
															})}
															{/* Mostrar datos combinados */}
															<li>
																<strong>{t("aux.period")}:</strong>
																<ul>
																	{combinedData.map(({ day, periods, ...rest }) => (
																		<li key={day}>
																			{`${day}:`}
																			<ul>
																				{periods.length > 0 ? (
																					periods.map(({ start_time, end_time }, index) => (
																						<li key={index}>
																							{start_time === "No disponible" ? start_time : `${start_time} - ${end_time}`}
																						</li>
																					))
																				) : (
																					<li>{t("aux.no_data")}</li>
																				)}
																			</ul>
																		</li>
																	))}
																</ul>
															</li>
														</ul>
													</Grid>
												);
											})}
									</Grid>
								</>
							)}
						</Box>
					</CardContent>
				</Card>
			</Modal>

			{/* Modal para fecha de subir archivo */}
			<ModalFechaUpload
				open={openModalFile}
				onClose={() => setOpenModalFile(false)}
				selectedIdArea={site_id}
			/>
		</>
	);
};

export { ModuleSimulation };
